export default "__VITE_ASSET__CWNOkFmh__"